import { Container, FloatingLabel, Form } from 'react-bootstrap';
import { generalHelpers } from '@monorepo/helpers';
import { hideLoadingModalReducer, refreshUserReducer, setConfigurationReducer, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { Loading } from '../_commons';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';
import { useNavigate } from 'react-router-dom';
import { userServices } from 'src/services';

export const RecoveryPage = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const queryParams = Object.fromEntries(urlSearchParams.entries());
    //
    const [confPassword, setConfPassword] = useState('');
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [password, setPassword] = useState('');
    const dispatch = useDispatch();
    const id = queryParams.id;
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();
    const navigate = useNavigate();
    const team = queryParams.team;

    const openAlertModalHandler = (title: string, message: string, animation?: number, execution?: Function): void => {
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'alert',
            title,
            message,
            animation,
            execution
        }));
    }
    
    const recoverAccountByTokenHandler = async (): Promise<void> => {
        if (!team || !id || !email || !generalHelpers.IsValidEmail(email) || !password || !confPassword) {
            openAlertModalHandler("Faltan datos", "");
            return;
        }
        if (password.length < 8) {
            openAlertModalHandler("La contraseña es demasiado corta (mín 8)", "");
            return;
        }
        if (password !== confPassword) {
            openAlertModalHandler("La contraseña no coincide con su confirmación", "");
            return;
        }
        const congr = parseInt(team);
        if (isNaN(congr)) {
            openAlertModalHandler("Hay un error en los datos", "");
            return;
        }
        dispatch(showLoadingModalReducer());
        const response = await userServices.ChangeMyPassword(congr, null, password, id);
        if (!response.success) {
            dispatch(hideLoadingModalReducer());
            openAlertModalHandler(response.message.title, response.message.description, 2);
            return;
        }
        const { user, config } = await userServices.GetUserByToken();
        if (!user || !config) {
            dispatch(hideLoadingModalReducer());
            openAlertModalHandler("Problemas (2)", "Refrescar la página; ver si hay internet", 2);
            return;
        }
        dispatch(refreshUserReducer(user));
        dispatch(setConfigurationReducer(config));
        dispatch(hideLoadingModalReducer());
        openAlertModalHandler("Clave cambiada con éxito", "", 1, () => navigate('/'));
    }

    useEffect(() => {
        if (!id || !team || email) {
            return;
        }
        userServices.GetEmailByEmailLink(team, id).then(response => {
            setIsLoading(false);
            if (!response.success || !response.data?.email) {
                dispatch(setValuesAndOpenAlertModalReducer({
                    mode: 'alert',
                    title: `El link no es válido (${response.message.title})`,
                    message: response.message.description,
                    execution: () => navigate('/'),
                    animation: 2
                }));
                return;
            }
            setEmail(response.data.email);
        });
    }, [email, id, team]);

    if (isLoading) {
        return <Loading />;
    }

    return (
        <Container className={isDarkMode ? 'bg-dark' : 'bg-white'}
            style={{
                border: '1px solid black',
                borderRadius: '12px',
                boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
                marginBottom: '50px',
                marginTop: '60px',
                maxWidth: '600px',
                padding: '50px 0 0'
            }}
        >
            <h2 className={`text-center mx-auto ${isDarkMode ? 'text-white' : ''}`}
                style={{
                    fontSize: isMobile ? '1.7rem' : '2rem',
                    maxWidth: '90%',
                    textShadow: '0 0 1px gray'
                }}
            >
                CAMBIAR LA CLAVE PARA RECUPERAR LA CUENTA
            </h2>
            <Container style={{ maxWidth: '500px', padding: isMobile ? '35px 30px 0' : '35px 0 0' }}>
                <FloatingLabel className={'mb-3 text-dark'}
                    label={!email ? "Cargando..." : "Correo electrónico"}
                >
                    <Form.Control type={'email'}
                        className={'form-control'}
                        autoComplete={'email'}
                        placeholder={""}
                        value={email}
                        onChange={() => {}}
                        disabled
                    />
                </FloatingLabel>
                <FloatingLabel label={"Nueva Contraseña"}
                    className={'mb-3 text-dark'}
                >
                    <Form.Control type={'password'}
                        className={'form-control'}
                        placeholder={""}
                        value={password}
                        onChange={e => setPassword((e.target as HTMLInputElement).value)}
                        autoFocus
                    />
                </FloatingLabel>
                <FloatingLabel className={'mb-3 text-dark'}
                    label={"Confirmar Nueva Contraseña"}
                >
                    <Form.Control type={'password'}
                        className={'form-control'}
                        value={confPassword}
                        placeholder={""}
                        onChange={e => setConfPassword((e.target as HTMLInputElement).value)}
                        onKeyDown={e => e.key === 'Enter' && !(!generalHelpers.IsValidEmail(email) || password.length < 8 || confPassword.length < 8 || password !== confPassword) ? recoverAccountByTokenHandler() : null }
                    />
                </FloatingLabel>
                <button className={'btn btn-general-blue d-block w-100 mt-5'}
                    style={{ fontWeight: 'bolder', height: '50px' }}
                    onClick={recoverAccountByTokenHandler}
                    disabled={!generalHelpers.IsValidEmail(email) || password.length < 8 || confPassword.length < 8 || password !== confPassword}
                >
                    CAMBIAR CLAVE
                </button>
                <button className={`btn btn-general-red d-block w-100 mt-4 mb-5`}
                    style={{ fontWeight: 'bolder', height: '50px' }}
                    onClick={() => navigate('/')}
                >
                    Cancelar
                </button>
            </Container>
        </Container>
    );
}
